'use strict';

angular.module('TurneroApp').service('bloqueoCalendarioService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/BloqueoCalendario/:id', { id: '@Id_Bloqueo_Calendario' }, {
        Get_Fecha_Hora: {
            method: 'GET',
            //params: {
            //    id_agenda: 'Id_Agenda'
            //},
            url: portal.getUrlServer() + 'api/BloqueoCalendario/Get_Fecha_Hora/:id_agenda/'
        },
        Get_Bloqueo_Calendario_Historial_Filtro: {
            method: 'GET',
            params: {
                id_centro_atencion: 'id_centro_atencion'
            },
            url: portal.getUrlServer() + 'api/BloqueoCalendario/Get_Bloqueo_Calendario_Historial_Filtro/:id_centro_atencion/'
        },
        Get_Bloqueo_Calendario: {
            method: 'GET',
            params: {
                id_centro_atencion: 'id_centro_atencion'
            },
            url: portal.getUrlServer() + 'api/BloqueoCalendario/Get_Bloqueo_Calendario/:id_centro_atencion/'
        },
        Get_Bloqueo_Calendario_Historial: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/BloqueoCalendario/Get_Bloqueo_Calendario_Historial/'
        },
        Post_Bloqueo_Calendario: {
            method: 'POST',
            url: portal.getUrlServer() + 'api/BloqueoCalendario/Post_Bloqueo_Calendario/'
        },
        Post_Desbloqueo_Calendario: {
            method: 'POST',
            params: { id_bloqueo: '@id_bloqueo' },
            url: portal.getUrlServer() + 'api/BloqueoCalendario/Post_Desbloqueo_Calendario'
        },
        Turnos_Afectados: {
            method: 'GET',
           // params: { value: '@value' },
            url: portal.getUrlServer() + 'api/BloqueoCalendario/Turnos_Afectados/'
        },
        'delete': {
            method: 'DELETE'
        },
        update: {
            method: 'PUT'
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/supervision/Bloqueo_Atencion/bloqueoCalendarioService.js